module.exports = __webpack_public_path__ + "static/impulso-bayer-3-9013b5eb33399269221061b2e75ff382.jpg";